import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { HeaderParams } from './types';
import AccountPersonaMenu from './AccountPersonaMenu';

const Header = ({ title, subTitle }: HeaderParams) => {
    const auth0 = useAuth0();

    return auth0.isAuthenticated ? (
        <div className="topbar">
            <div className="topbar-left">
                <h1 className="topbar-title">{title}</h1>
                <p className="topbar-sub">{subTitle}</p>
            </div>
            <div className="topbar-right">
                <AccountPersonaMenu />
            </div>
        </div>
    ) : null;
};

export default Header;